import Balance from './index';

export default { path: '/home/publicAccountBalance', component: Balance };
